theme.FeaturesScroller = new function () {
  class FeaturesScroller {
    constructor(container) {
      this.container = container;

      if (!this.container) {
        return false;
      }

      this.scrollingItems = [...this.container.querySelectorAll(this.selectors.scrollingItem)];

      new ResizeObserver(this.calculateScrollingSpeed.bind(this)).observe(this.container);
      new ResizeObserver(this.calculateAnimationDuration.bind(this)).observe(this.container);

      this.initEvents();
    }

    get selectors() {
      return {
        scrollingItem: "[data-features-scroller-item]",
        scrollingPauseButton: "[data-features-scroller-pause]"
      }
    }

    get modifiers() {
      return {
        scrollingPaused: "features-scroller__items--paused"
      }
    }

    get datasets() {
      return {
        scrollingSpeed: {
          desktop: "scrollingSpeedDesktop",
          mobile: "scrollingSpeedMobile"
        },
        scrollingPaused: "scrollingPaused"
      }
    }

    get breakpoints() {
      return {
        desktop: 992,
        mobile: 375
      }
    }

    get scrollingSpeed() {
      return this._scrollingSpeed;
    }

    set scrollingSpeed(speed) {
      this._scrollingSpeed = speed;
    }

    initEvents() {
      document.addEventListener("click", (event) => {
        const pauseButton = event.target.closest(this.selectors.scrollingPauseButton);

        if (!pauseButton) {
          return false;
        }

        this.toggleScrolling();
      });
    }

    calculateScrollingSpeed(resizeObserverEntries) {
      const resizeObserverEntry = resizeObserverEntries[0];

      const contentWidth = resizeObserverEntry.contentRect.width;

      const speed = contentWidth < this.breakpoints.desktop
        ? this.container.dataset[this.datasets.scrollingSpeed.mobile] || 10
        : this.container.dataset[this.datasets.scrollingSpeed.desktop] || 20;

      this.scrollingSpeed = parseInt(speed);
    }

    calculateAnimationDuration(resizeObserverEntries) {
      const resizeObserverEntry = resizeObserverEntries[0];
      const resizeObserverTarget = resizeObserverEntry.target;

      const contentWidth = resizeObserverEntry.contentRect.width;
      const slowingFactor = 1 + (Math.min(this.breakpoints.desktop, contentWidth) - this.breakpoints.mobile) / (this.breakpoints.desktop - this.breakpoints.mobile);

      const scrollingAnimationDuration = (this.scrollingSpeed * slowingFactor * resizeObserverTarget.querySelector(this.selectors.scrollingItem).clientWidth / contentWidth).toFixed(3);

      this.container.style.setProperty(
        "--marquee-animation-duration",
        `${scrollingAnimationDuration}s`
      );
    }

    toggleScrolling() {
      const isScrollingPaused = this.container.dataset[this.datasets.scrollingPaused] === "true";

      if (isScrollingPaused) {
        this.container.dataset[this.datasets.scrollingPaused] = false;

        this.scrollingItems.forEach((scrollingItem) =>
          scrollingItem.classList.remove(this.modifiers.scrollingPaused)
        );
      } else {
        this.container.dataset[this.datasets.scrollingPaused] = true;

        this.scrollingItems.forEach((scrollingItem) =>
          scrollingItem.classList.add(this.modifiers.scrollingPaused)
        );
      }
    }
  }

  this.onSectionLoad = async function (container) {
    if (!container) {
      return false;
    }

    return new FeaturesScroller(container);
  };
}();

theme.Sections.register("features-scroller", theme.FeaturesScroller);
